const evaluation_formRouter = [
  {
      path: "evaluation-form",
      name: "evaluation_form",
      component: () => import("@/views/admin/evaluation_form"),
      default: true,
      meta: {
          model: "evaluation_form",
          // requiresAuth: true,
      },
  },
  {
      path: "evaluation-form/add",
      name: "addEvaluationForm",
      component: () => import("@/views/admin/evaluation_form/function"),
      default: true,
      meta: {
          model: "evaluation_form",
          // requiresAuth: true,
      },
  },
  {
      path: "evaluation-form/edit/:id",
      name: "editEvaluationForm",
      component: () => import("@/views/admin/evaluation_form/function"),
      default: true,
      meta: {
          model: "evaluation_form",
          // requiresAuth: true,
      },
  },
  {
    path: "evaluation-form/detail/:id",
    name: "detailEvaluationForm",
    component: () => import("@/views/admin/evaluation_form/detail"),
    default: true,
    meta: {
        model: "evaluation_form",
        // requiresAuth: true,
    },
}
]
export default evaluation_formRouter;